<script lang="ts">
	import type { PointsInfoBannerContent } from '../../domain/points-info-banner/PointsInfoBannerContent.ts';
	import type { PointsInfoBannerType } from '../../domain/points-info-banner/PointsInfoBannerType.ts';
	import { onMount } from 'svelte';
	import TrackingService, { ActionName } from '../../services/tracking/TrackingService.ts';
	import { Topic } from '../../services/tracking/Topic.ts';
	import { onViewport } from '../../services/tracking/IntersectionObserver';
	import { sheetV1 } from '@otto-ec/otto-components/sheet';


	let trackingService: TrackingService;

	let { pointsInfoBannerContent, pointsInfoBannerType }: {
		pointsInfoBannerContent: PointsInfoBannerContent,
		pointsInfoBannerType: PointsInfoBannerType,
	} = $props();

	const trackClick = () => {
		trackingService.sendEvent(Topic.SubmitEvent, {
			up_PointsBanner: [ActionName.OPEN],
			up_BannerType: [pointsInfoBannerType]
		}
		);
	}

	const trackSeen = () => {
		trackingService.sendEvent(Topic.SubmitEvent, {
			up_PointsBanner: [ActionName.SEEN],
			up_BannerType: [pointsInfoBannerType]
		}
		);
	}

	const trackView = () => {
		trackingService.sendEvent(Topic.MergeEvent, {
			up_PointsBanner: [ActionName.VIEW],
			up_BannerType: [pointsInfoBannerType]
		}
		);
	}

	const createSheet = async () => {
		await sheetV1.create({
			open: true,
			id: 'points-info-banner-sheet',
			headline: pointsInfoBannerContent.sheetTitle,
			url: pointsInfoBannerContent.sheetUrl,
			noContentPadding: true
		});
	}

	const click = async () => {
		trackClick();
		await createSheet();
	}

	onMount(() => {
		trackingService = new TrackingService();
		trackView();
	});

</script>
<div class="points-info-banner"
	id="points-info-banner"
	data-testid="points-info-banner"
	data-sheet-full-bleed-content="true"
	style="cursor: pointer; display:flex;"
	data-points-info-banner-type={pointsInfoBannerType}
	onmousedown={trackSeen}
	use:onViewport
	onenterViewport={trackSeen}
>
	<oc-icon-v1 data-testid="icon_otto-up-points" class="oc-mr-75" oc-aria-label="otto-up-punkte"
		type="otto-up-points"></oc-icon-v1>

	<oc-link-v2
		variant="secondary"
		as-button=""
		data-testid="points-info-banner-description"
		onclick={click}
	>
		{pointsInfoBannerContent.description}
	</oc-link-v2>
</div>
